// Shared between the column header row and each TemplateCard row so the
// "Sections" and "Created" values line up under their labels.
export const TEMPLATE_LIST_GRID_COLS = "grid-cols-[1fr_120px_140px]";
